@if (batch.forecastAvailable) {
  <colimo-accordion-wrapper
    [headerTitle]="'dashboard.colorCareInfoHeadline' | translate"
    [showOnlyOnMobile]="true"
    >
    @if (!isMobile) {
      <div>
        <div class="batch-info colorCare" [ngClass]="'gap'">
          <p class="batch-info-label">ColorCare {{ forecastMeasurementResult }}</p>
        </div>
        @if (batch.forecastMeasurements) {
          <div>
            <div class="form-field-group">
              @if (batch.forecastMeasurements) {
                <button
                  class="refresh-button"
                  mat-icon-button
                  matTooltip="{{ 'dashboard.updateForecastMeasurements' | translate }}"
                  [matTooltipPosition]="'above'"
                  [disabled]="isForecastMeasurementLoading"
                  (click)="updateForecastMeasurementsByBatchId()"
                  >
                  <mat-icon>refresh</mat-icon>
                </button>
              }
              <mat-form-field appearance="fill">
                <mat-label class="select-label">{{ 'dashboard.selectForecastMeasurement' | translate }}</mat-label>
                <mat-select
                  name="selectedForecastMeasurement_{{ batch.batchId }}"
                  [(ngModel)]="selectedForecastMeasurement"
                  (selectionChange)="selectedMeasurementChanged($event.value)"
                  [disabled]="isForecastMeasurementLoading"
                  id="forecastmeasurement_{{ batch.batchId }}"
                  >
                  @for (option of batch.forecastMeasurements; track option.id) {
                    <mat-option [value]="option" [colimoMultiLineTooltip]="option.metaSummary">{{
                      option.info
                    }}</mat-option>
                  }
                </mat-select>
                @if (selectedForecastMeasurement) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="selectedMeasurementChanged(undefined); $event.stopPropagation()"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>
          </div>
        }
      </div>
    }
    @if (isMobile) {
      <div class="flex-column">
        <div class="batch-info">
          <p class="batch-info-label">ColorCare {{ forecastMeasurementResult }}</p>
        </div>
        @if (batch.forecastMeasurements) {
          <div>
            <div class="form-field-group">
              @if (batch.forecastMeasurements) {
                <button
                  class="refresh-button"
                  mat-icon-button
                  matTooltip="{{ 'dashboard.updateForecastMeasurements' | translate }}"
                  [matTooltipPosition]="'above'"
                  [disabled]="isForecastMeasurementLoading"
                  (click)="updateForecastMeasurementsByBatchId()"
                  >
                  <mat-icon>refresh</mat-icon>
                </button>
              }
              <mat-form-field appearance="fill">
                <mat-label class="select-label">{{ 'dashboard.selectForecastMeasurement' | translate }}</mat-label>
                <mat-select
                  name="selectedForecastMeasurement_{{ batch.batchId }}"
                  [(ngModel)]="selectedForecastMeasurement"
                  (selectionChange)="selectedMeasurementChanged($event.value)"
                  [disabled]="isForecastMeasurementLoading"
                  id="forecastmeasurement_{{ batch.batchId }}"
                  >
                  @for (option of batch.forecastMeasurements; track option.id) {
                    <mat-option [value]="option" [colimoMultiLineTooltip]="option.metaSummary">{{
                      option.info
                    }}</mat-option>
                  }
                </mat-select>
                @if (selectedForecastMeasurement) {
                  <button
                    matSuffix
                    mat-icon-button
                    aria-label="Clear"
                    (click)="selectedMeasurementChanged(undefined); $event.stopPropagation()"
                    >
                    <mat-icon>close</mat-icon>
                  </button>
                }
              </mat-form-field>
            </div>
          </div>
        }
      </div>
    }
  </colimo-accordion-wrapper>
}
